import { Gauge } from 'lucide-react'

/**
 * Story 3.16.1 — Display read-only para settings numéricas tipo
 * threshold/confidence (0..1 ou 0..max). Renderiza barra visual com
 * 10 segments + label semântica.
 *
 * Default scale 0..1 cobre opt_out_ai_confidence_min,
 * anti_repetition_threshold. Para openai_temperature (0..2), passe
 * `max=2` explicitamente.
 */
export function ThresholdDisplay({
  value,
  max = 1,
}: {
  value: unknown
  max?: number
}): React.ReactElement {
  if (typeof value !== 'number' || !Number.isFinite(value)) {
    return <code className="text-xs text-muted-foreground">(valor inválido)</code>
  }
  const pct = Math.max(0, Math.min(1, value / max))
  const filled = Math.round(pct * 10)
  const bar = '●'.repeat(filled) + '○'.repeat(10 - filled)
  const percentLabel = `${Math.round(pct * 100)}%`
  const semantic = describeLevel(pct)

  return (
    <div className="flex items-center gap-2 text-sm">
      <Gauge className="h-3.5 w-3.5 text-muted-foreground" aria-hidden="true" />
      <span className="font-medium">
        {max === 1 ? percentLabel : value.toFixed(2)}
      </span>
      <span className="font-mono text-xs text-muted-foreground" aria-hidden="true">
        {bar}
      </span>
      <span className="text-xs text-muted-foreground">{semantic}</span>
    </div>
  )
}

function describeLevel(pct: number): string {
  if (pct >= 0.85) return 'muito alto'
  if (pct >= 0.65) return 'alto'
  if (pct >= 0.35) return 'médio'
  if (pct >= 0.15) return 'baixo'
  return 'muito baixo'
}
